import { baseFetch } from "../api/baseFetch";
import { membersLink, tokenLink } from "../credentials/consts/links";
export var ApiBearerToken;
(function (ApiBearerToken) {
    ApiBearerToken.get = async (accountId) => {
        return baseFetch({
            method: "GET",
            withCredentials: true,
            accountId,
            url: `${membersLink}${tokenLink}`,
            params: {
                accountId,
            },
        });
    };
})(ApiBearerToken || (ApiBearerToken = {}));
